import { useInteractiveCallback } from '@/hook/useInteractiveCallback';
import { Flow } from '@/types/flow.type';

import { useAppDispatch, useAppSelector } from '../store';

import { setFlows, renameFlow, FLOWS_REDUCER_NAME } from './flows.slice';

// SELECTORS
export function useFlows() {
    return useAppSelector((state) => state[FLOWS_REDUCER_NAME]);
}

export function useFlowsData() {
    const flowsData = useAppSelector((state) => state.flows.data);

    return flowsData;
}

export function useFlowsDataByCode(code: string) {
    const flowsData = useFlowsData();

    return flowsData.find((flow) => flow.code === code);
}

// DISPATCHERS
export function useSetFlows() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((flows: Flow[]) => {
        dispatch(setFlows({ flows }));
    });
}

export function useRenameFlow() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((flowCode: string, name: string) => {
        dispatch(renameFlow({ flowCode, name }));
    });
}
